class FlickitySlider extends HTMLElement {
  constructor() {
    super();
    this.flkty = null;
    this.sliderInitialized = false;
  }

  connectedCallback() {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(this);
          }
        });
      }, { rootMargin: '400px' });
      observer.observe(this);
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    if (this.flkty) {
      this.flkty.destroy();
      this.flkty = null;
    }
  this.sliderInitialized = false;

  }

  get options() {
    try {
      return this.hasAttribute("data-options")
        ? JSON.parse(this.getAttribute("data-options"))
        : {};
    } catch (e) {
      console.error("Invalid JSON in data-options:", e);
      return {};
    }
  }

  get defaultOptions() {
    return {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
    };
  }

  init() {
    if (this.sliderInitialized) return;
    if (typeof Flickity === "undefined") {
      setTimeout(() => this.init(), 100);
      return;
    }

    // Get slides (direct children)
    this.slides = Array.from(this.children);

    // Ensure slides are displayed
    this.slides.forEach((slide) => {
      slide.style.display = "block";
      slide.style.visibility = "visible";
    });

    // Initialize Flickity
    this.flkty = new Flickity(
      this,
      Object.assign({}, this.defaultOptions, this.options)
    );

    this.sliderInitialized = true;
  }
}

if (!customElements.get("flickity-slider")) {
  customElements.define("flickity-slider", FlickitySlider);
}
